import {removeSupplierNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function removeSupplierNoteMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.removeSupplierNote,
    mutationFn: (noteId: number) => removeSupplierNote(supplierId, noteId),
    onSuccess: async (_data, _noteId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
